import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();
  return (
    <footer style={{
      background: 'white', borderTop: '1px solid var(--border)',
      padding: '20px 24px', textAlign: 'center', marginTop: 40
    }}>
      <p style={{ color: 'var(--text-light)', fontSize: 13, marginBottom: 8 }}>
        © {new Date().getFullYear()} חנות יצירות ומלאכות — כל הזכויות שמורות
      </p>
      <button
        onClick={() => navigate('/admin')}
        style={{ background: 'none', border: 'none', color: 'transparent', fontSize: 12, cursor: 'default', userSelect: 'none' }}>
        ניהול
      </button>
    </footer>
  );
}
